class CarouselComponent extends HTMLElement {
  constructor() {
    super();
    
    this.carousel = this.querySelector('.carousel-component');

    if (!this.carousel) return;
    
    this.itemSelector = '.carousel-item';
    this.timeout = null;   
    this.time = this.dataset.interval || 5000;    
    this.isSticky = this.dataset.sticky;

    if (document.body.dataset.pagetype == 'cart') {
      this.isSticky = false;
    }

    if (this.isSticky) {
      const marginTop = this.carousel.clientHeight * -1;
      const observer = new window.IntersectionObserver((entries) => {

      // 2022-04-18: when customer starts personalization -> make header non-sticky
      var cookieName = 'sp_image_params',
          imageParams = document.cookie.match(new RegExp(cookieName + '=([^;]+)'));
        
        if (imageParams) {
          this.carousel.classList.remove('sticky');
          return;
        }
        
        if (entries[0].isIntersecting) {
          this.carousel.classList.remove('sticky');
        } else {
          this.carousel.classList.add('sticky');
        }
      },{
        root: null,
        rootMargin: marginTop + 'px 0px 0px 0px',
        threshold: 0,
      });

      observer.observe(this);
    }

    this.initAnimation();
  }

  initAnimation() {	
    // we only need one listener since all items are moved simultaneously
    this.querySelectorAll(this.itemSelector)[0].addEventListener('animationend',this.onAnimationend.bind(this));
    
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(this.showNext.bind(this),this.time);
  }

  onAnimationend = function() {

    let items = this.querySelectorAll('.carousel-item');

    // remove animation class
    items.forEach((item,index) => item.classList.remove('slide'));

    // move first item to last
    items[0].parentElement.appendChild(items[0]);
    
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(this.showNext.bind(this),this.time);
  }

  showNext() {
    this.querySelectorAll('.carousel-item').forEach((item,index) => item.classList.add('slide'));
  }
}

customElements.define('carousel-component', CarouselComponent);

class GalleryCloseBtnComponent extends HTMLElement {
  constructor() {
    super();
    
    // only on mobile
    if (!this.is_touch_enabled()) return;

    this.body = document.querySelector('body');
    this.galleryViewer = document.querySelector("slider-component[id^='GalleryViewer']");
    this.productSlider = document.querySelector(".sp_gallery-container");
    this.galleryThumbnails = document.querySelector("slider-component[id^='GalleryThumbnails']");

    this.closeGalleryBtn = document.querySelector('.btn-close-fixed-gallery');
    this.sliderInView = true;

    if (!this.productSlider) return;

    // prevent elements from jumping when gallery gets "fixed"
    this.galleryViewer.style.height = this.galleryViewer.clientHeight + 'px';

    const observer = new IntersectionObserver((entries,observer) => this.onObserve(entries,observer),
    {
      root: null,
      rootMargin: '-150px 0px 0px 0px',
      threshold: 0,
    });
    observer.observe(this.galleryThumbnails);

    this.closeGalleryBtn.addEventListener('click',() => {
      if (this.productSlider.classList.contains('open')) {
        this.productSlider.classList.remove('open');
      } else {
        this.productSlider.classList.add('open'); 
      }
    });

    // close gallery wehen soft keyboard is visible
    document.querySelectorAll('input').forEach(
      (elem) => elem.addEventListener('focus', this.closeGallery.bind(this))
    );
  }

  openGallery() {
    this.productSlider.classList.add('open');
  }

  closeGallery() {
    this.productSlider.classList.remove('open');
  }

  fixGallery() {
      let margin = 10;
      //this.productSlider.style.height = (this.productSlider.clientHeight + margin) + 'px';
      this.productSlider.style.top = ((this.productSlider.clientHeight * -1) + 40) + 'px';
      this.productSlider.classList.add('fixed');
  }
  
  unfixGallery() {
      this.productSlider.classList.remove('open');
      this.style.display = '';
      this.productSlider.style.height = 'auto';
      this.productSlider.classList.remove('fixed');
  }
  
  onObserve(entries,observer) {
    var observed = entries[0];
    this.sliderInView = observed.isIntersecting;
    if (observed.isIntersecting) {
      this.unfixGallery();
      this.body.classList.remove('gallery_not_in_viewport');
    } else {
      this.fixGallery();
      this.body.classList.add('gallery_not_in_viewport');
    }
  }

  notify(state) {
    // only on mobile
    if (!this.is_touch_enabled()) return;
    if (!this.sliderInView) {
      this.classList.remove('done');
      this.classList.remove('loading');
      this.classList.add(state);
    }
    if (state === 'loading') {
      // don't use this.body here
      document.querySelector('body').classList.add('personalisation_started');
    }
  }

  is_touch_enabled() {
    return ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
  }
}

customElements.define('gallery-close-btn-component', GalleryCloseBtnComponent);



/*
2025-10-04 - Not in use anymore
*/
class StickyPreviewInfoComponent extends HTMLElement {
  constructor() {
    super();
    
    // only on mobile
    if (!this.is_touch_enabled()) return;

    this.body = document.querySelector('body');
    this.galleryViewer = document.querySelector("slider-component[id^='GalleryViewer']");
    this.productSlider = document.querySelector(".sp_gallery-container");
    this.galleryThumbnails = document.querySelector("slider-component[id^='GalleryThumbnails']");

    this.showGalleryBtn = this.querySelector('.loading_done_info');
    this.closeGalleryBtn = document.querySelector('.btn-close-fixed-gallery');
    this.sliderInView = true;

    if (!this.productSlider) return;

    // prevent elements from jumping when gallery gets "fixed"
    this.galleryViewer.style.height = this.galleryViewer.clientHeight + 'px';

    const observer = new IntersectionObserver((entries,observer) => this.onObserve(entries,observer),
    {
      root: null,
      rootMargin: '-150px 0px 0px 0px',
      threshold: 0,
    });
    observer.observe(this.galleryThumbnails);

    this.showGalleryBtn.addEventListener('click',() => {
      this.fixGallery();
    });

    this.closeGalleryBtn.addEventListener('click',() => {
      if (this.productSlider.classList.contains('open')) {
        this.productSlider.classList.remove('open');
      } else {
        this.productSlider.classList.add('open'); 
      }
    });

    // close gallery wehen soft keyboard is visible
    document.querySelectorAll('input').forEach(
      (elem) => elem.addEventListener('focus', this.unfixGallery.bind(this))
    );
  }

  fixGallery() {
      console.log('fixGallery');
      this.style.display = 'none';
      let margin = 10;
      this.productSlider.style.height = (this.productSlider.clientHeight + margin) + 'px';
      this.productSlider.classList.add('fixed');
  }
  
  unfixGallery() {
      console.log('unfixGallery');
      this.productSlider.classList.remove('open');
      this.style.display = '';
      this.productSlider.style.height = 'auto';
      this.productSlider.classList.remove('fixed');
  }
  
  onObserve(entries,observer) {
    var observed = entries[0];
    this.sliderInView = observed.isIntersecting;
    if (observed.isIntersecting) {
      this.unfixGallery();
      this.body.classList.remove('gallery_not_in_viewport');
    } else {
      this.fixGallery();
      this.body.classList.add('gallery_not_in_viewport');
    }
  }

  notify(state) {
    // only on mobile
    if (!this.is_touch_enabled()) return;
    if (!this.sliderInView) {
      this.classList.remove('done');
      this.classList.remove('loading');
      this.classList.add(state);
      /*
      if (state === 'loading') {
        this.classList.remove('inactive');
      }
      */
    }
    if (state === 'loading') {
      // don't use this.body here
      document.querySelector('body').classList.add('personalisation_started');
    }
  }

  is_touch_enabled() {
    return ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
  }
}

customElements.define('sticky-preview-info-component', StickyPreviewInfoComponent);
  
class AccordionComponent extends HTMLElement {
  constructor() {
    super();
    this.accordion = this.querySelector('.sp_accordion');
    this.headers = this.querySelectorAll('.sp_accordion--card-header');
    this.cards = this.querySelectorAll('.sp_accordion--card');
    if (!this.accordion) return;
    this.headers.forEach(
      (header) => header.addEventListener('click', this.onButtonClick.bind(this))
    );   
  }

  onButtonClick(event) {
    event.preventDefault();
    let isOpen = event.target.parentNode.classList.contains('open');
    // close all bodys    
    this.cards.forEach((card) => card.classList.remove('open'));
    // open clicked card
    if (!isOpen) event.target.parentNode.classList.add('open');
  }
}

customElements.define('accordion-component', AccordionComponent);

class CountdownComponent extends HTMLElement {
  constructor() {
    super();

    if (!this.dataset.enddate || !this.dataset.endtime) {
      return;
    }
    
    this.firstrun = true;
    this.countDownDate = new Date(this.dataset.enddate + 'T' + this.dataset.endtime).getTime();   
    this.itemDays = this.querySelector('.countdown-item-days');
    this.containerDays = this.querySelector('.countdown-days');
    this.containerHours = this.querySelector('.countdown-hours');
    this.containerMinutes = this.querySelector('.countdown-minutes');
    this.containerSeconds = this.querySelector('.countdown-seconds');
    this.showDays = this.dataset.showdays === 'false' ? false : true;    
    this.interval = setInterval(this.count.bind(this),1000);
  }

  count() {

    // Get today's date and time
    let now = new Date().getTime();

    if (isNaN(this.countDownDate) || isNaN(now)) {
      this.querySelector('.countdown-component').style.display = 'none';
      console.log('countdown: isNaN (1)',this.countDownDate,now);
      clearInterval(this.interval);
      return;
    }

    // Find the distance between now and the count down date
    let distance = this.countDownDate - now;

    if (isNaN(distance)) {
      this.querySelector('.countdown-component').style.display = 'none';
      console.log('countdown: isNaN (2)');
      clearInterval(this.interval);
      return;
    }

    // If the count down is finished, write some text
    if (distance < 0) {
      clearInterval(this.interval);
      this.querySelector('.countdown-component').classList.remove('countdown-active');
      return;
    }
    
    // Time calculations for days, hours, minutes and seconds
    let days    = this.showDays ? Math.floor(distance / (1000 * 60 * 60 * 24)) : 0;
    let hours   = Math.floor(distance / 36e5) - (days*24);
    let minutes = Math.floor((distance % 36e5) / 6e4);
    let seconds = Math.floor((distance % 6e4) / 1000);

    days = days < 10 ? '0' + days : days;
    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;

    if (this.showDays) this.containerDays.innerHTML = days;
    this.containerHours.innerHTML = hours;
    this.containerMinutes.innerHTML = minutes;
    this.containerSeconds.innerHTML = seconds;

    //if (days > 0) {
    //  this.itemDays.style.display = 'block';
    //}

    if (this.firstrun) {
      this.querySelector('.countdown-label-days').innerHTML = days == 1 ? 'Tag' : 'Tage';
      this.querySelector('.countdown-component').style.opacity = 1;
    }
  }
}

customElements.define('countdown-component', CountdownComponent);

class CircleCountdownComponent extends HTMLElement {
  constructor() {
    super();

    if (!this.dataset.enddate || !this.dataset.endtime) {
      return;
    }

    let countDownDate = new Date(this.dataset.enddate + 'T' + this.dataset.endtime).getTime(),
        countDownContainer = this,
        showDays = this.dataset.showdays === 'false' ? false : true,
        $r;

    let ringer = {
      rings: {
        /*
        'TAGE': { 
          s: 86400000, // mseconds in a day,
          max: 365
        },
        */
        'STD': {
          s: 3600000, // mseconds per hour,
          max: 24
        },
        'MIN': {
          s: 60000, // mseconds per minute
          max: 60
        },
        'SEK': {
          s: 1000,
          max: 60
        }/*,
        'MSEK': {
          s: 10,
          max: 100
        }*/
      },
      r_count: 3,
      r_spacing: 10, // px
      r_size: 50, // px
      r_thickness: 2, // px
      update_interval: 11, // ms
      init: function() {
        let ratio = window.devicePixelRatio;
        $r = ringer;
        $r.width = ($r.r_size + $r.r_thickness) * $r.r_count + ($r.r_spacing*($r.r_count-1));
        $r.height = $r.r_size + $r.r_thickness;
        $r.cvs = document.createElement('canvas');      
        $r.size = { 
          w: ratio * $r.width,
          h: ratio * $r.height
        }; 
        $r.cvs.setAttribute('width',$r.size.w);           
        $r.cvs.setAttribute('height',$r.size.h);
        $r.cvs.style.width = $r.width + "px";
        $r.cvs.style.height = $r.height + "px";
        $r.cvs.getContext("2d").scale(ratio,ratio);
        $r.ctx = $r.cvs.getContext('2d');
        countDownContainer.append($r.cvs);
        $r.cvs = $($r.cvs);    
        $r.ctx.textAlign = 'center';
        $r.actual_size = $r.r_size + $r.r_thickness;
        $r.countdown_to_time = countDownDate;
        $r.go();
      },
      ctx: null,
      go: function(){
        var idx=0;
        $r.time = (new Date().getTime()) - $r.countdown_to_time;
        for(var r_key in $r.rings) $r.unit(idx++,r_key,$r.rings[r_key]);           
        setTimeout($r.go,$r.update_interval);
      },
      unit: function(idx,label,ring) {
        var x,y, value, ring_secs = ring.s;
        value = parseFloat($r.time/ring_secs);
        $r.time-=Math.round(parseInt(value)) * ring_secs;
        value = Math.abs(value);
        
        x = ($r.r_size*.5 + $r.r_thickness*.5);
        x +=+(idx*($r.r_size+$r.r_spacing+$r.r_thickness));
        y = $r.r_size*.5;
        y += $r.r_thickness*.5;
        
        // calculate arc end angle
        var degrees = 360-(value / ring.max) * 360.0;
        var endAngle = degrees * (Math.PI / 180);

        $r.ctx.save();
        
        $r.ctx.translate(x,y);
        $r.ctx.clearRect($r.actual_size*-0.5,$r.actual_size*-0.5,$r.actual_size,$r.actual_size);
        
        // first circle
        $r.ctx.strokeStyle = "rgba(128,128,128,0.3)";
        $r.ctx.beginPath();
        $r.ctx.arc(0,0,$r.r_size/2,0,2 * Math.PI, 2);
        $r.ctx.lineWidth =$r.r_thickness;
        $r.ctx.stroke();
        
        // second circle
        $r.ctx.strokeStyle = "rgba(255,255,255, 0.9)";
        $r.ctx.beginPath();
        $r.ctx.arc(0,0,$r.r_size/2,0,endAngle, 1);
        $r.ctx.lineWidth =$r.r_thickness;
        $r.ctx.stroke();
        
        // label
        $r.ctx.fillStyle = "#ffffff";
        $r.ctx.font = 'bold 10px Helvetica';
        $r.ctx.fillText(label, 0, 20);

        // time
        $r.ctx.font = 'bold 28px Helvetica';
        $r.ctx.fillText(Math.floor(value), 0, 9);
        
        $r.ctx.restore();
      }
    }
  
    ringer.init();
  }
}

customElements.define('circle-countdown-component', CircleCountdownComponent);

class SimpleCountdownComponent extends HTMLElement {
  constructor() {
    super();
    if (!this.dataset.enddate || !this.dataset.endtime) {
      return;
    }
    this.countDownStartDate = this.dataset.startdate && this.dataset.starttime ? new Date(this.dataset.startdate + 'T' + this.dataset.starttime).getTime() : new Date().getTime();   
    this.countDownEndDate = new Date(this.dataset.enddate + 'T' + this.dataset.endtime).getTime();   
    this.countdownOutput = this.querySelector('.sp_simple-countdown-output');
    this.interval = setInterval(this.count.bind(this),1000);
  }

  count() {

    // Get today's date and time
    let now = new Date().getTime();

    if (isNaN(this.countDownStartDate) ||isNaN(this.countDownEndDate) || isNaN(now)) {
      console.log('countdown: isNaN (1)',this.countDownEndDate,now);
      clearInterval(this.interval);
      this.remove();
      return;
    }

    if (this.countDownStartDate > now) {
      console.log('Countdown has not yet started');
      clearInterval(this.interval);
      this.remove();
      return;
    }

    // Find the distance between now and the count down date
    let distance = this.countDownEndDate - now;

    if (isNaN(distance)) {
      console.log('countdown: isNaN (2)');
      clearInterval(this.interval);
      this.remove();
      return;
    }

    // If the count down is finished, write some text
    if (distance < 0) {
      clearInterval(this.interval);
      this.remove();
      return;
    }

    let prefix = this.dataset.prefix || '';
    let suffix = this.dataset.suffix || '';
    // Time calculations for days, hours, minutes and seconds
    let days    = this.showDays ? Math.floor(distance / (1000 * 60 * 60 * 24)) : 0;
    let hours   = Math.floor(distance / 36e5) - (days*24);
    let minutes = Math.floor((distance % 36e5) / 6e4);
    let seconds = Math.floor((distance % 6e4) / 1000);

    days = days > 0 ? days : '';
    if (days) {
      days = days == 1 ? days + ' Tag, ' : days + ' Tage, ';
    }
    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;

    this.countdownOutput.innerHTML = prefix + days + hours + ':' + minutes + ':' + seconds + suffix;
  }
}

customElements.define('simple-countdown-component', SimpleCountdownComponent);